<template>
  <div>
    <ParentBar></ParentBar>
    <v-card min-height="700" flat>
      <div>
        <v-overlay color="white" opacity="1" absolute v-show="!isSuccess">
          <v-progress-circular large color="green" indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <div v-show="isSuccess">
          <Headline
            :sub-title-top="$t('customer.customer_profile')"
            badge-content
            :content="
              customer.type == 'company' ? customer.companyName : getFullname
            "
            :sub-title-bottom="
              customer.type == 'company' ? $t('customer.type.company') : $t('customer.type.personal')
            "
            :tabs="tabs"
            @onCreated="fetchData"
          >
            <div>
              <div class="d-flex justify-end">
                <v-btn
                  class="mb-2 info"
                  @click="isAddCompanionDialog = true"
                  v-if="tabs && tabs==2"
                >
                  <v-icon left>mdi-plus-box-multiple-outline</v-icon>{{ $t('customer.add_companion_seller') }}
                </v-btn>
              </div>
              <div v-if="tabs !== 0" class="d-flex align-center">
                <v-text-field
                  solo
                  dense
                  background-color="grey lighten-4"
                  flat
                  type="text"
                  :placeholder="$t('search')"
                  :label="$t('search')"
                  prepend-inner-icon="mdi-magnify"
                  v-model="search"
                  clearable
                  color
                  hide-details
                  class="mx-1"
                ></v-text-field>
              </div>
            </div>
          </Headline>
          <v-container style="max-width: 1800px">
            <v-tabs
              grow
              elevation="0"
              hide-slider
              active-class="border-2 rounded-xl"
              v-model="tabs"
            >
              <!-- <div class="py-5"> -->
              <button
                :class="
                  tabs == 0
                    ? `w-1/2 primary rounded-xl border-2 text-white`
                    : 'w-1/2 rounded-xl border-2'
                "
                elevation="0"
                @click="tabs = 0"
              >{{ $t('customer.customer_information') }}</button>
              <button
                :class="
                  tabs == 1
                    ? `w-1/2 primary rounded-xl text-white`
                    : 'w-1/2 border-2 border-gray-200 rounded-xl'
                "
                elevation="0"
                @click="tabs = 1, search = ''"
              >{{ $t('contract.contract_information') }}</button>
              <button
                :class="
                  tabs == 2
                    ? `w-1/2 primary rounded-xl text-white`
                    : 'w-1/2 border-2 border-gray-200 rounded-xl'
                "
                elevation="0"
                @click="tabs = 2, search = ''"
              >{{ $t('customer.companion_party_information') }}</button>
              <!-- </div> -->
              <v-tab-item>
                <ProfileDetail @onLoad="getCustomer"></ProfileDetail>
              </v-tab-item>
              <v-tab-item class="py-5">
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <FormContract v-model="dialog" event="create" @addProduct="areaProduct = true"></FormContract>
                  </div>
                </div>
                <div class="p-5">
                  <CustomerContract v-if="tabs == 1" :projectId="projectId" :marketId="marketId" :search="search" />
                </div>
              </v-tab-item>
              <v-tab-item class="py-5">
                <CompanionCustomers
                  :projectId="projectId"
                  :marketId="marketId"
                  :isKeyword="false"
                  :isMainLoading="false"
                  :customer="customer"
                  :isDetail="false"
                  :search="search"
                />
              </v-tab-item>
            </v-tabs>
          </v-container>
        </div>
      </div>
    </v-card>
    <v-snackbar v-model="isError" color="error">{{ $t('error_loading_data') }}</v-snackbar>
    <FormCompanion
      v-model="isAddCompanionDialog"
      :event="'create'"
      :projectId="projectId"
      @onCreated="fetchData"
      :customer="customer"
    />
  </div>
</template>

<script>
import CustomerContract from "../../components/CustomerContract.vue";
import ProfileDetail from "../../components/ProfileDetail.vue";
import FormContract from "../../components/FormContract";
import { mapActions, mapGetters, mapState } from "vuex";
import Headline from "../../components/Headline";
import ParentBar from "../../components/ParentBar";
import CompanionCustomers from "../../components/CompanionCustomers";
import FormCompanion from "../../components/FormCompanion";
export default {
  components: {
    CustomerContract,
    ProfileDetail,
    FormContract,
    Headline,
    ParentBar,
    CompanionCustomers,
    FormCompanion
  },
  computed: {
    ...mapState({
      products: state => state.product.getProducts
    }),
    ...mapGetters({
      customer: "customer/getCustomer",
      getFullname: "customer/getFullName",
      getCustomerContract: "customer/getCustomerContract"
    })
  },
  name: "CustomerId",
  created() {
    this.checkQuery();
    this.getCustomer();
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      dialog: false,
      isSuccess: false,
      isError: false,
      updateCustomerDialog: false,
      areaProduct: false,
      tabs: 0,
      isLoading: false,
      isAddCompanionDialog: false,
      search: ""
    };
  },
  methods: {
    checkQuery() {
      if (this.$route.query && this.$route.query.tabs) {
        this.tabs = parseInt(this.$route.query.tabs);
      }
    },
    saveArea() {},
    ...mapActions({
      getProduct: "product/getProducts",
      getVacancyAreas: "area/getVacancyAreas"
    }),
    async getCustomer() {
      try {
        await this.$store.dispatch("customer/getCustomer", {
          id: this.$route.params.customerId
        });
        await this.getContractsByCustomer();
        this.isSuccess = true;
      } catch (e) {
        this.isSuccess = true;
      }
    },
    async getContractsByCustomer() {
      try {
        await this.$store.dispatch("contract/getContractsByCustomer", {
          customerId: this.$route.params.customerId,
          isFetchLog: true
        });
        this.isSuccess = true;
      } catch (e) {
        this.isSuccess = true;
      }
    },
    async fetchData() {
      this.isLoading = true;
      try {
        if (this.$route.params.customerId) {
          await this.$store.dispatch("companion/getCompanionsByCustomer", {
            projectId: this.projectId,
            limit: 20,
            page: 0,
            order: {},
            customerId: this.$route.params.customerId
          });
          await this.getContractsByCustomer();
        }
        this.isLoading = false;
      } catch (error) {
        console.log("err", error);
        this.isLoading = false;
        this.isError = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
